import React from 'react'
import styled from 'styled-components'

function RecentName() {
  return (
    <Container>
      <Wrapper>
        ITEMS IN CART
      </Wrapper>
    </Container>
  )
}

export default RecentName


const Wrapper = styled.div`
font-weight: 600;
font-size: 20px;
height: 60px;
background-color: #6C757D;
display: flex;
justify-content: center;
align-items: center;
color: white;


`

const Container = styled.div`

`


